module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/pppclubbeddeath005#toc"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_c('b', [_vm._v("Since Death on All")])]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("Since death on all lays his impartial hand")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("And all resign at his command,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("The stoic too, as well as I,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("With all his gravity must die;")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Let’s wisely manage this last span,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("The momentary life of man;")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("And still in pleasure’s circle move,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Giving our days to friends, and all our nights to love.")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Then while we are here let’s thus perfectly live")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("And taste all the pleasures that nature can give;")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Fresh heat when life’s fading our wine will inspire,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("And fill all our veins with a nobler fire.")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("When we’re sapless, old and impotent,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Then we shall grieve for youth misspent;")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Wine and women only can")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Cherish the heavy heart of man.")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Let’s drink on till our blood o’erflows")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Its channels, and luxuriant grows,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Then when our whores have drained each vein")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("And the thin mass fresh spirits crave, let’s drink again.")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Then while we are here let’s thus perfectly live")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("And taste all the pleasures that nature can give;")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Fresh heat when life’s fading our wine will inspire,")]), _vm._v(" "), _c('p', {
    staticClass: "epl"
  }, [_vm._v("And fill all our veins with a nobler fire.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—John Wilmot, Earl of Rochester")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26095c62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pppclubbeddeath006.vue
// module id = 72
// module chunks = 0